/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */
export { default as pubsubPropagation } from './pubsub-propagation';
